import {FormHelperText, MenuItem, Select} from '@mui/material'
import React, {FC} from 'react'


interface Props {
    value: any,
    name: string

    handleChange(val: any): void,

    handleSubmit?(): void,

    icon?: any,
    items: Array<{
        id: number | undefined,
        address: string
    }> | undefined,
    width?: string,
    height?: string,
    bgc?: string,
    bRadius?: string,
    helperText?: any,
    isDisabled?: boolean
}


const CustomAddressSelect: FC<Props> = ({
                                            value,
                                            handleChange,
                                            icon,
                                            items,
                                            name, width,
                                            height = "40px",
                                            bRadius = "5px",
                                            isDisabled,
                                            helperText,
                                            bgc = "#FFFFFF",
                                            handleSubmit
                                        }) => {

    const onChange = (e: any) => {
        handleChange(e)
        handleSubmit && handleSubmit()
    }
    return <>
        <Select
            value={value}
            onChange={onChange}
            name={name}
            IconComponent={icon && icon}
            disabled={isDisabled}
            sx={{
                height: height,
                background: bgc,
                borderRadius: bRadius,
                color: "primary.dark",
                width: width,
                fontSize: "16px"
            }}
        >
            {items && items.length > 0 && items.map((item) => {
                    return <MenuItem key={item.id}
                                     value={item.id}
                                     sx={{
                                         color: "primary.dark",
                                     }}

                    >{item.address}</MenuItem>
                }
            )}
        </Select>
        <FormHelperText sx={{color: "#FC4B4A"}}>
            {helperText}
        </FormHelperText>
    </>
}

export default CustomAddressSelect